import { useContext } from "react";
import { ProjectPlanPageContext, PageNewState } from ".";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(ProjectPlanPageContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
